import { render, staticRenderFns } from "./dialogSnack.vue?vue&type=template&id=01e15e53&"
import script from "./dialogSnack.vue?vue&type=script&lang=js&"
export * from "./dialogSnack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports